const frequentlyAskedQuestions = {
  en: {
    title: 'Frequently Asked Questions',
    desc: '',
    items: [
      {
        question: 'Is the Chowbus POS system right for my Boba Tea?',
        answer: `Yes! Chowbus POS is a perfect fit for boba tea. We work with thousands of restaurants across the US, with notable restaurant names such as Machi Machi, Tiger Suger, Moge Tee, Tsao Caa, and Te’amo.`,
      },
      {
        question: 'What are the most popular features of Chowbus POS for Boba Tea?',
        answer: `Our most popular features are: 
        <a href="/products/point-of-sale">Restaurant Management</a>: Menu management, Order management, Staff management
        Smart Ordering: <a href="/products/kiosk">Kiosk</a>
        Online Service: <a href="/products/thirdparty-integration">3rd Party Integration</a>
        Retention: <a href="/products/loyalty">Loyalty</a>, CRM`,
      },
      {
        question: 'How much does Chowbus POS cost for Boba Tea?',
        answer: `Chowbus offers flexible sales solutions, including providing equipment at no cost, reducing the barriers to accessing our high-quality products and services. You can also <a href="/get-a-demo?source=Q&A">schedule a demo</a> to receive a personalized quote.`,
      },

      {
        question: 'Does Chowbus offer packages for new restaurants opening?',
        answer: `Chowbus POS is the top choice for new restaurants. For detailed packages, you can <a href="/get-a-demo">schedule a demo</a> with us, and we will have a dedicated representative to provide you with a customized solution.`,
      },
    ],
  },
  zh: {
    title: '常见问题',
    desc: '',
    items: [
      {
        question: '我应该选择Chowbus POS产品吗？',
        answer: `当然！Chowbus POS是快捷餐厅的首选！我们为上千家餐厅提供服务，包括著名的朝茶、愿茶、老虎堂、功夫茶等。`,
      },
      {
        question: '我应该用哪些产品及服务？',
        answer: `您可以根据您的餐厅特点和诉求针对性地选择我们的产品。我们推荐您使用我们的智能餐厅管理系统统一管理餐厅菜单、订单、员工等；使用智能点餐机/网页等提升点餐、支付效率；使用第三方外卖平台集成服务增加订单管理效率；使用会员系统提升餐厅复购率。`,
      },
      {
        question: 'Chowbus POS产品多少钱？',
        answer: `Chowbus提供灵活的销售方案，包括免费设备方案，降低您使用我们高质量的产品及服务的门槛，现在<a href="/zh/get-a-demo?source=Q&A">联系我们</a>获取专属报价。`,
      },
      {
        question: 'Chowbus为新开业的餐厅提供外带服务吗？',
        answer: `Chowbus POS是新餐厅的首选。详细的合作方案可以预约我们的Demo，我们将有专人服务，为您提供专属定制方案。`,
      },
    ],
  },
};

export default frequentlyAskedQuestions;
